// Helper for formatting date
export const formatDateLocaleDDMMYY = (date: Date, locale: string) => {
  return date.toLocaleDateString(locale, { day: '2-digit', month: '2-digit', year: '2-digit' });
};
